import { render } from "./EmployeeApprovedPayments.vue?vue&type=template&id=c05c0994"
import script from "./EmployeeApprovedPayments.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedPayments.vue?vue&type=script&lang=js"

import "./EmployeeApprovedPayments.vue?vue&type=style&index=0&id=c05c0994&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__